// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rXR2","clinicsSelect":"styles_clinicsSelect__326zr"};